export const AdminBaseUrl = "/admin_panel";
